import type { PortfolioProject } from '../types/content'

export const portfolioCategories = [
  'Todos',
  'Cleaning Services USA',
  'Academias & Deportes',
  'Beauty, Nails & Estética',
  'Productos Digitales',
  'Gym & Fitness',
]

export const portfolioProjects: PortfolioProject[] = [
  {
    id: 'cleaning',
    name: 'Shine Home Cleaning',
    category: 'Cleaning Services USA',
    businessType: 'Servicio de limpieza residencial · Estados Unidos',
    description:
      'Landing page creada para recibir solicitudes de cotización por WhatsApp y formulario.',
    videoSrc: 'https://cdn.magicpatterns.com/uploads/5dgSAFXrji1wrvDZ6MfDwq/pagweblimpieza (1).mp4',
  },
  {
    id: 'soccer',
    name: 'NY Elite Soccer Academy',
    category: 'Academias & Deportes',
    businessType: 'Academia de fútbol · Nueva York',
    description:
      'Página web conectada a Stripe para pagos, formularios directos para citas, mensajes de texto (SMS), WhatsApp y redes sociales.',
    videoSrc: 'https://cdn.magicpatterns.com/uploads/tAHmQrE2uw54LHHgLhwqjp/pagsoccer (1).mp4',
  },
  {
    id: 'beauty',
    name: 'Studio Bella Nails',
    category: 'Beauty, Nails & Estética',
    businessType: 'Salón de belleza, uñas y estética',
    description:
      'Página diseñada para mostrar servicios y recibir citas directas por WhatsApp.',
    videoSrc: 'https://cdn.magicpatterns.com/uploads/m3ZpkoCLTKiXUrTW5G2rTo/pagunas (1) (1).mp4',
  },
  {
    id: 'digital',
    name: 'Guía Marca Digital',
    category: 'Productos Digitales',
    businessType: 'Ebook y curso online',
    description:
      'Página de venta persuasiva para presentar el producto digital y cerrar la compra.',
    videoSrc: 'https://cdn.magicpatterns.com/uploads/hjEntJzPuJ6mvd8JKbm5M1/pagwebconshopify (1).mp4',
  },
  {
    id: 'gym',
    name: 'Power Move Gym',
    category: 'Gym & Fitness',
    businessType: 'Gimnasio y entrenamiento personal',
    description:
      'Página enfocada en llenar clases y agendar sesiones de prueba desde el celular.',
    videoSrc: 'https://cdn.magicpatterns.com/uploads/1DkpyGz2gJiCSufhZ3Gyst/pagwebgym (1).mp4',
  },
]
